import React from 'react';
import {
  List,
  Header,
  Label,
  Checkbox,
  Loader,
} from 'semantic-ui-react';
import { rangeValueKeys } from '../constants';

const ValueListFacet = ({
  category,
  code,
  facetConfig,
  facetKey,
  facet,
  filter,
  handleFilterUpdate,
  isLoading,
  canUpdate,
}) => {
  const rangeValue = (facetValue) => {
    if ('from' in facetValue && 'to' in facetValue) {
      return { from: facetValue.from, to: facetValue.to };
    }
    if ('from' in facetValue) {
      return { from: facetValue.from };
    }
    if ('to' in facetValue) {
      return { to: facetValue.to };
    }
    return {};
  };

  const indexOfFacetValue = (list, facetValue) => list.findIndex(
    (el) => JSON.stringify(el) === JSON.stringify(rangeValue(facetValue)),
  );

  const toggleSelected = (facetValue) => {
    if (!canUpdate) return;

    const newFilter = [...filter];
    if ('value' in facetValue) {
      if (newFilter.includes(facetValue.value)) {
        newFilter.splice(newFilter.indexOf(facetValue.value), 1);
      } else { newFilter.push(facetValue.value); }
    } else if ('from' in facetValue || 'to' in facetValue) {
      const params = rangeValue(facetValue);
      if (indexOfFacetValue(newFilter, params) > -1) {
        newFilter.splice(indexOfFacetValue(newFilter, params), 1);
      } else { newFilter.push(params); }
    }

    handleFilterUpdate(facetKey, newFilter);
  };

  const isChecked = (facetValue) => {
    if ('from' in facetValue || 'to' in facetValue) {
      return (filter.some((vals) => JSON.stringify(vals) === JSON.stringify(rangeValue(facetValue))));
    }
    return filter.includes(facetValue.value);
  };

  const makeRangeLabel = (facetValue) => {
    let label = '';
    if (rangeValueKeys.FROM in facetValue) {
      label = rangeValueKeys.TO in facetValue
        ? label = `${facetValue[rangeValueKeys.FROM]} - ${facetValue[rangeValueKeys.TO]}`
        : `> ${facetValue[rangeValueKeys.FROM]}`;
    } else {
      label = `< ${facetValue[rangeValueKeys.TO]}`;
    }
    return label;
  };

  const makeRangeKey = (facetValue) => {
    let label = '';
    if (rangeValueKeys.FROM in facetValue) {
      label = rangeValueKeys.TO in facetValue
        ? label = `${facetValue[rangeValueKeys.FROM]}_${facetValue[rangeValueKeys.TO]}`
        : `${facetValue[rangeValueKeys.FROM]}`;
    } else {
      label = `${facetValue[rangeValueKeys.TO]}`;
    }
    return label;
  };

  const getCheckboxLabel = (facetValue) => {
    if (typeof facetValue === 'string') {
      return facetValue;
    }
    if ('value' in facetValue) {
      return facetValue.value;
    }
    return makeRangeLabel(facetValue);
  };

  const getItemKey = (facetValue) => {
    if (typeof facetValue === 'string') {
      return facetValue;
    }
    if ('value' in facetValue) {
      return facetValue.value;
    }
    return makeRangeKey(facetValue);
  };

  const getCheckboxId = (name, facetValue) => (
    `facet_checkbox_${category}_${code}_${name}_${getItemKey(facetValue)}`
  );

  return (
    <>
      <Header as="h4">
        {facetConfig.label}
        {
          isLoading && <Loader active inline size="tiny" />
        }
      </Header>
      <List>
        {
          facet.map((facetValue) => (
            <List.Item
              key={`value_list_facet_item_${category}_${code}_${facetConfig.name}_${getItemKey(facetValue)}`}
              className="aridhia-facet-list-item"
            >
              {(canUpdate || isChecked(facetValue)) && (
              <Checkbox
                onChange={() => toggleSelected(facetValue)}
                id={getCheckboxId(facetConfig.name, facetValue)}
                label={(
                  <label htmlFor={getCheckboxId(facetConfig.name, facetValue)}>
                    {getCheckboxLabel(facetValue)}
                    {' '}
                    {canUpdate && (
                    <Label circular size="mini">
                      {facetValue.count}
                    </Label>
                    )}
                  </label>
                )}
                checked={isChecked(facetValue)}
                value={facetValue.value}
                disabled={!canUpdate}
              />
              )}
            </List.Item>
          ))
        }
      </List>
    </>
  );
};

export default ValueListFacet;
